import React from 'react';
import styles from './ReachCounter.module.css';

class ReachCounter extends React.Component {
  render() {
    const { reach = 268000, pct = 100 } = this.props;

    const fmt = n => n >= 1000 ? (n / 1000).toFixed(1) + 'K' : String(n);
    const android = Math.round(reach * 0.948);
    const ios     = reach - android;

    return (
      <div className={styles.counter}>
        <div className={styles.numWrap}>
          <div className={styles.num}>{fmt(reach)}</div>
          <div className={styles.label}>Est. Audience</div>
        </div>
        <div className={styles.barWrap}>
          <div className={styles.barTrack}>
            <div className={styles.barFill} style={{ width: Math.min(100, pct) + '%' }} />
          </div>
          <div className={styles.split}>
            <div className={styles.splitItem}>
              <div className={styles.dot} style={{ background: '#B84242' }} />
              <span>Android · {fmt(android)}</span>
            </div>
            <div className={styles.splitItem}>
              <div className={styles.dot} style={{ background: '#5080B8' }} />
              <span>iOS · {fmt(ios)}</span>
            </div>
          </div>
        </div>
        <div className={styles.pctWrap}>
          <div className={styles.pct}>{pct}%</div>
          <div className={styles.pctLbl}>of MAU</div>
        </div>
      </div>
    );
  }
}

export default ReachCounter;
